import React from 'react'
import PropTypes from 'prop-types'
import { withFirebase } from 'react-redux-firebase'

class HomeContainer extends React.Component {
  static contextTypes = {
    router: PropTypes.shape({
      history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired,
        createHref: PropTypes.func.isRequired,
      }).isRequired,
    }).isRequired,
  }

  constructor() {
    super()
    this.state = {
      inputValue: '',
    }
  }

  checkCode = (evt) => {
    evt.preventDefault()

    const drawingId = this.state.inputValue
    const self = this

    if (drawingId) {
      this.props.firebase
        .database()
        .ref(`/drawings/${drawingId}`)
        .once('value')
        .then(function(snapshot) {
          const drw = snapshot.val()
          if (!drw) {
            self.setState({ error: 'Sorry, that code was not found' })
          } else {
            self.context.router.history.push(`/drawings/${drawingId}`)
          }
        })
    } else {
      this.setState({ error: "Enter piccle's code!" })
    }
  }

  updateInputValue = (evt) => {
    this.setState({
      inputValue: evt.target.value.toLowerCase(),
    })
  }

  render() {
    return (
      <div className="container">
        <form onSubmit={this.checkCode}>
          <h2>Enter your code</h2>
          {this.state.error && <span className="error">{this.state.error}</span>}
          <br />
          <input type="text" className="form-field" value={this.state.inputValue} onChange={this.updateInputValue} />
          <button type="submit" onClick={this.checkCode}>
            Let&apos;s Draw
          </button>
        </form>
      </div>
    )
  }
}

export default withFirebase(HomeContainer)



// WEBPACK FOOTER //
// ./src/containers/homeContainer.js